'use client';

import { useLingui } from '@lingui/react';
import { LanguageCode } from '@prismo-io/schemas';
import type { AuthFlowType } from '@supabase/supabase-js';
import { useMemo } from 'react';
import { createApiClient } from './create-api-client';

type Options = {
  flowType: AuthFlowType;
};

const DEFAULT_OPTIONS: Options = {
  flowType: 'pkce',
};

export const useApi = (options: Partial<Options> = DEFAULT_OPTIONS) => {
  const { i18n } = useLingui();

  const locale = useMemo(() => {
    try {
      return LanguageCode.parse(i18n.locale);
    } catch (error) {
      return LanguageCode.Enum.fr;
    }
  }, [i18n.locale]);

  return useMemo(() => {
    const client = createApiClient({ ...options, locale });

    return { client };
  }, [locale]);
};
